import { render, staticRenderFns } from "./mainApp.vue?vue&type=template&id=720e733c&scoped=true&"
import script from "./mainApp.vue?vue&type=script&lang=js&"
export * from "./mainApp.vue?vue&type=script&lang=js&"
import style0 from "./mainApp.vue?vue&type=style&index=0&lang=less&"
import style1 from "./mainApp.vue?vue&type=style&index=1&lang=css&"
import style2 from "./mainApp.vue?vue&type=style&index=2&id=720e733c&scoped=true&lang=css&"
import style3 from "./mainApp.vue?vue&type=style&index=3&lang=css&"
import style4 from "./mainApp.vue?vue&type=style&index=4&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "720e733c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/procure-web-seven-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('720e733c')) {
      api.createRecord('720e733c', component.options)
    } else {
      api.reload('720e733c', component.options)
    }
    module.hot.accept("./mainApp.vue?vue&type=template&id=720e733c&scoped=true&", function () {
      api.rerender('720e733c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/main/mainApp.vue"
export default component.exports